import { render, staticRenderFns } from "./DeleteDocumentWindow.vue?vue&type=template&id=7c1f792f"
import script from "./DeleteDocumentWindow.vue?vue&type=script&lang=js"
export * from "./DeleteDocumentWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports